module.exports = __webpack_public_path__ + "img/vistalegrelogo.10f0c225.png";